module.exports = __webpack_public_path__ + "img/nacional.c9d9c3a0.png";